export const TAB_IDS = [
  "users",
  "sessions",
  "pageviews",
  "session-duration",
  "bounce-rate",
  "session-user",
] as const;

export type TabId = typeof TAB_IDS[number];

/** Map TabId to backend metric_selector value */
export const TAB_ID_TO_METRIC_SELECTOR: Record<TabId, string> = {
  users: "Users",
  sessions: "Sessions",
  pageviews: "Pageviews",
  "session-duration": "Session Duration",
  "bounce-rate": "Bounce Rate",
  "session-user": "Avg. Session Per User",
};

export interface RegionRow {
  name: string;
  city?: string;
  country?: string | string[];
  value: number;
  changePercent?: number;
}

export interface AgeRow {
  name: string;
  value: number;
  percent: number;
  changePercent?: number;
}

export interface GenderOrDeviceRow {
  name: string;
  value: number;
  percent: number;
}

export interface ChannelRow {
  name: string;
  value: number;
  changePercent: number;
  trendData: number[];
}

export interface DemographicsData {
  regions: RegionRow[];
  ages: AgeRow[];
  gender: GenderOrDeviceRow[];
  device: GenderOrDeviceRow[];
}

/** Pre-ranked (descending), backend-aggregated location lists, capped at the requested `limit`. */
export interface TopLocations {
  city: RegionRow[];
  country: RegionRow[];
}

export interface TabData {
  demographics: DemographicsData;
  channels: ChannelRow[];
  topLocations: TopLocations;
}
